import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FaviconService
{
  private favIcon: HTMLLinkElement = document.querySelector('#appIcon');

  public setAppIcon(): void
  {
    this.favIcon.href = './assets/images/logos/Channels360_Icon.png';
  }
}
